// noinspection DuplicatedCode

import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useSnackbar } from 'notistack';
import Paper from '@/modules/common/components/Paper';
import Button from '@/modules/common/components/Button';
import Content from '@/modules/common/components/Content';
import Spinner from '@/modules/common/components/Spinner';
import ErrorFetch from '@/modules/common/components/ErrorFetch';
import Pagination from '@/modules/common/components/Pagination';
import ContentBody from '@/modules/common/components/ContentBody';
import ContentHeader from '@/modules/common/components/ContentHeader';
import ContentBodyTop from '@/modules/common/components/ContentBodyTop';
import { withFetch } from '~/hocs/fetch';
import { withRouter } from '~/hocs/router';
import Table from './Table';
import DialogAdd from './DialogAdd';
import DialogEdit from './DialogEdit';
import ContextMenu from './ContextMenu';
import DialogDelete from './DialogDelete';
import '../styles/Prices.scss';

let abortController;

const Prices = (props) => {
    const { username } = useParams();
    const { enqueueSnackbar } = useSnackbar();

    const breadcrumbs = [
        {name: 'Пользователи', to: '/users/'},
        {name: username, to: `/users/${username}/`},
        {name: 'Цены'}
    ];

    const [loading, setLoading] = useState(true);
    const [data, setData] = useState(null);
    const [selectedPrice, setSelectedPrice] = useState(null);
    const [openDialogAdd, setOpenDialogAdd] = useState(false);
    const [openDialogEdit, setOpenDialogEdit] = useState(false);
    const [openDialogDelete, setOpenDialogDelete] = useState(false);
    const [autoCloseDialogAdd, setAutoCloseDialogAdd] = useState(true);
    const [positionContextMenu, setPositionContextMenu] = useState({left: null, top: null});

    const fetch = () => {
        abortController = new AbortController();
        setLoading(true);
        props.fetch.get(`/api/prices/?${props.router.urlSearchParams.toString()}`, abortController)
            .then(({ok, data}) => {
                if (ok) {
                    setData(data);
                }
                setLoading(false);
            })
            .catch((error) => {
                setData(null);
                if (error.name !== 'AbortController') {
                    setLoading(false);
                }
            })
            .finally(() => {
                abortController = null;
            });
    };

    const closeContextMenu = () => {
        setPositionContextMenu({left: null, top: null});
    };

    useEffect(() => {
        return () => {
            if (abortController) {
                abortController.abort();
            }
        };
    }, []);

    useEffect(() => {
        let page = parseInt(props.router.urlSearchParams.get('page'));

        if (isNaN(page)) {
            page = 1;
        }
        props.router.urlSearchParams.set('username', username);
        // noinspection JSCheckFunctionSignatures
        props.router.urlSearchParams.set('page', page);

        fetch();
    }, [props.history.location.search]);

    /******************************************************************************************************************/

    const handleContextMenu = (price) => (event) => {
        event.preventDefault();
        setSelectedPrice(price);
        setPositionContextMenu({left: event.clientX, top: event.clientY});
    };

    const handleClickEdit = () => {
        closeContextMenu();
        setOpenDialogEdit(true);
    };

    const handleClickDelete = () => {
        closeContextMenu();
        setOpenDialogDelete(true);
    };

    const handleCloseContextMenu = () => {
        closeContextMenu();
        setSelectedPrice(null);
    };

    /******************************************************************************************************************/

    const handleAddOk = () => {
        if (autoCloseDialogAdd) {
            setOpenDialogAdd(false);
            props.router.reload();
        }
        enqueueSnackbar('Цена добавлена', {variant: 'success'});
    };

    const handleEditOk = () => {
        setOpenDialogEdit(false);
        setSelectedPrice(null);
        props.router.reload();
        enqueueSnackbar('Цена изменена', {variant: 'success'});
    };

    const handleDeleteOk = () => {
        setOpenDialogDelete(false);
        setSelectedPrice(null);
        props.router.reload();
        enqueueSnackbar('Цена удалена', {variant: 'success'});
    };

    /******************************************************************************************************************/

    // noinspection JSUnresolvedVariable
    return (
        <Content id="prices">
            <ContentHeader breadcrumbs={breadcrumbs}/>
            <ContentBody><Paper>
                {(!loading)
                    ? <>
                        {(data && data.results)
                            ? <>
                                <ContentBodyTop left={
                                    <Button onClick={() => setOpenDialogAdd(true)}>Добавить</Button>
                                }/>
                                <DialogAdd open={openDialogAdd} setOpen={setOpenDialogAdd} onOk={handleAddOk}
                                           autoClose={autoCloseDialogAdd} setAutoClose={setAutoCloseDialogAdd}
                                />
                                {(data.results.length > 0)
                                    ? <>
                                        <Table prices={data.results} selectedPrice={selectedPrice}
                                               onContextMenu={handleContextMenu}
                                        />
                                        <ContextMenu position={positionContextMenu}
                                                     onClickEdit={handleClickEdit}
                                                     onClickDelete={handleClickDelete}
                                                     onClose={handleCloseContextMenu}
                                        />
                                        <DialogEdit selectedPrice={selectedPrice} setSelectedPrice={setSelectedPrice}
                                                    open={openDialogEdit} setOpen={setOpenDialogEdit}
                                                    onOk={handleEditOk}
                                        />
                                        <DialogDelete selectedPrice={selectedPrice} setSelectedPrice={setSelectedPrice}
                                                      open={openDialogDelete} setOpen={setOpenDialogDelete}
                                                      onOk={handleDeleteOk}
                                        />
                                        <Pagination totalPages={data.total_pages} currentPage={data.current_page}/>
                                    </>
                                    : null
                                }
                            </>
                            : <ErrorFetch onClick={() => fetch()}/>
                        }
                    </>
                    : <Spinner/>
                }
            </Paper></ContentBody>
        </Content>
    );
};

let Component = Prices;
Component = withRouter(Component);
Component = withFetch(Component);

export default Component;
